import React from "react";
import { Formik } from "formik";
import * as qs from "query-string";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { TextField } from "@mui/material";
import { findEmailByToken, setPassword  } from "../../api/auth";
import * as auth from "../../store/ducks/auth.duck";
import { Link, useLocation } from "react-router-dom";

function ResetPassword(props) {
  const location = useLocation();
  const [token, setToken] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [invalid, setInvalid] = React.useState(true);

  React.useEffect(() => {
    async function fetchEmail(key) {
      const mail = await findEmailByToken(key);
      setEmail(mail);
    }
    if (location && location.search) {
      const parsed = qs.parse(location.search);
      if (parsed.token) {
        setInvalid(false);
        fetchEmail(parsed.token);
        setToken(parsed.token);
      }
    }
  }, [location]);

  return (
    <div className="kt-login__body">
      <div className="kt-login__form">
        <div className="kt-login__title">
          <h3>Kata Laluan baru</h3>
        </div>
        {invalid ? (
          <>
            <div role="alert" className="alert alert-danger">
              <div className="alert-text">Invalid token</div>
            </div>
            <Link to="/auth">
              <button
                type="button"
                className="btn btn-secondary btn-elevate kt-login__btn-secondary"
              >
                Back
              </button>
            </Link>
          </>
        ) : (
          <Formik
            initialValues={{
              password: "",
              confirmPassword: ""
            }}
            validate={values => {
              const errors = {};

              if (!values.password) {
                errors.password = "Password is Required";
              }

              if (!values.confirmPassword) {
                errors.confirmPassword  = "Confirm Password is Required";
              } else if (values.password !== values.confirmPassword) {
                errors.confirmPassword =
                  "Password and Confirm Password didn't match.";
              }

              return errors;
            }}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              setPassword(undefined, values.password, token)
                .then(result => {
                  const { accessToken } = result;
                  props.login(accessToken);
                })
                .catch((err) => {
                  console.log(err)
                  setSubmitting(false);
                  setStatus("Akaun gagal diaktifkan");
                });
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form onSubmit={handleSubmit} noValidate autoComplete="off">
                {status && (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{status}</div>
                  </div>
                )}

                <div className="form-group mb-0">
                  <TextField
                    margin="normal"
                    label="Email"
                    className="kt-width-full"
                    name="Email"
                    onBlur={handleBlur}
                    value={email}
                    disabled
                  />
                </div>

                <div className="form-group mb-0">
                  <TextField
                    type="password"
                    margin="normal"
                    label="Password"
                    className="kt-width-full"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    type="password"
                    margin="normal"
                    label="Confirm Password"
                    className="kt-width-full"
                    name="confirmPassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirmPassword}
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    error={Boolean(
                      touched.confirmPassword && errors.confirmPassword
                    )}
                  />
                </div>

                <div className="kt-login__actions">
                  <button
                    disabled={isSubmitting || values.password !== values.confirmPassword}
                    className="btn btn-primary btn-elevate kt-login__btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));
